export default __webpack_public_path__ + "static/media/favourites.b07c86d5.svg";